export const breakpointValues = {
  LRG: 1024,
  MED: 1023,
  SML: 766,
} as const;

export type BreakPointVals = keyof typeof breakpointValues;

export default {
  LRG: `@media(min-width: ${breakpointValues.LRG}px)`,
  MED: `@media(max-width: ${breakpointValues.MED}px)`,
  SML: `@media(max-width: ${breakpointValues.SML}px)`,
  nav: {
    LRG: "@media(min-width: 1366px)",
    MED: "@media(min-width: 961px) and (max-width: 1365px)",
    SML: "@media(max-width: 960px)",
  },
};

export const breakpointTokens = {
  desktop: "(max-width: 1800px)",
  phone: "(max-width: 600px)",
  smallDesktop: "(max-width: 960px)",
  tabletLandscape: "(max-width: 1200px)",
  tabletPortrait: "(max-width: 900px)",
  LRG: `(min-width: ${breakpointValues.LRG}px)`,
  MED: `(max-width: ${breakpointValues.MED}px)`,
  SML: `(max-width: ${breakpointValues.SML}px)`,
  nav: {
    LRG: "(min-width: 1366px)",
    MED: "(min-width: 961px) and (max-width: 1365px)",
    SML: "(max-width: 960px)",
  },
};
